import { render, staticRenderFns } from "./ModificarPassword.vue?vue&type=template&id=615cd2bd"
import script from "./ModificarPassword.vue?vue&type=script&lang=js"
export * from "./ModificarPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports